import React, { useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export const ForgotPasswordModal = ({ initialEmail = '', onClose }) => {
  const [step, setStep] = useState(1); // 1=email, 2=código+clave, 3=éxito
  const [email, setEmail] = useState(initialEmail);
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const detailToText = (d) =>
    typeof d === 'string' ? d : (Array.isArray(d) ? d.map(e => e.msg).join(' ') : 'Error, intenta de nuevo');

  const requestCode = async (e) => {
    e.preventDefault();
    if (!email) { setError('Escribe tu correo'); return; }
    setLoading(true); setError('');
    try {
      await axios.post(`${API}/api/auth/forgot-password`, { email: email.trim().toLowerCase() });
      setStep(2);
    } catch (err) {
      setError(detailToText(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  const submitReset = async (e) => {
    e.preventDefault();
    if (!code || code.length !== 6) { setError('El código tiene 6 dígitos'); return; }
    if (!newPassword) { setError('Escribe tu nueva contraseña'); return; }
    setLoading(true); setError('');
    try {
      await axios.post(`${API}/api/auth/reset-password`, {
        email: email.trim().toLowerCase(), code, new_password: newPassword,
      });
      setStep(3);
    } catch (err) {
      setError(detailToText(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" data-testid="forgot-password-modal">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-6">
        {step === 1 && (
          <form onSubmit={requestCode}>
            <h3 className="text-lg font-bold text-slate-900">Recuperar contraseña</h3>
            <p className="text-sm text-slate-500 mt-1">Te enviaremos un código de 6 dígitos a tu correo.</p>
            {error && <div className="mt-3 text-sm text-red-600 bg-red-50 rounded-lg px-3 py-2" data-testid="forgot-error">{error}</div>}
            <input
              type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@email.com" autoFocus
              className="mt-4 w-full h-12 border border-slate-300 rounded-xl px-4 text-base focus:ring-2 focus:ring-green-600 focus:outline-none"
              data-testid="forgot-email-input"
            />
            <button type="submit" disabled={loading}
              className="mt-4 w-full h-12 bg-green-700 hover:bg-green-800 text-white rounded-xl font-semibold disabled:opacity-50"
              data-testid="forgot-send-code-btn">
              {loading ? 'Enviando...' : 'Enviar código'}
            </button>
          </form>
        )}

        {step === 2 && (
          <form onSubmit={submitReset}>
            <h3 className="text-lg font-bold text-slate-900">Revisa tu correo 📬</h3>
            <p className="text-sm text-slate-500 mt-1">
              Si <b>{email}</b> está registrado, te llegó un código de 6 dígitos (revisa spam). Válido por 15 minutos.
            </p>
            {error && <div className="mt-3 text-sm text-red-600 bg-red-50 rounded-lg px-3 py-2" data-testid="reset-error">{error}</div>}
            <input
              type="text" inputMode="numeric" maxLength={6} value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
              placeholder="000000" autoFocus
              className="mt-4 w-full h-12 border border-slate-300 rounded-xl px-4 text-center text-2xl tracking-[8px] font-bold focus:ring-2 focus:ring-green-600 focus:outline-none"
              data-testid="reset-code-input"
            />
            <input
              type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Nueva contraseña" autoComplete="new-password"
              className="mt-3 w-full h-12 border border-slate-300 rounded-xl px-4 text-base focus:ring-2 focus:ring-green-600 focus:outline-none"
              data-testid="reset-new-password-input"
            />
            <p className="text-[11px] text-slate-400 mt-1">Mínimo 8 caracteres, con mayúscula, minúscula y número.</p>
            <button type="submit" disabled={loading}
              className="mt-4 w-full h-12 bg-green-700 hover:bg-green-800 text-white rounded-xl font-semibold disabled:opacity-50"
              data-testid="reset-submit-btn">
              {loading ? 'Verificando...' : 'Cambiar contraseña'}
            </button>
            <button type="button" onClick={() => { setStep(1); setError(''); }}
              className="mt-2 w-full text-sm text-slate-500 hover:text-slate-700">
              ← Usar otro correo
            </button>
          </form>
        )}

        {step === 3 && (
          <div className="text-center" data-testid="reset-success">
            <div className="text-5xl mb-3">✅</div>
            <h3 className="text-lg font-bold text-slate-900">¡Contraseña actualizada!</h3>
            <p className="text-sm text-slate-500 mt-1">Ya puedes iniciar sesión con tu nueva contraseña.</p>
            <button onClick={onClose}
              className="mt-5 w-full h-12 bg-green-700 hover:bg-green-800 text-white rounded-xl font-semibold"
              data-testid="reset-done-btn">
              Iniciar sesión
            </button>
          </div>
        )}

        {step !== 3 && (
          <button onClick={onClose} className="mt-3 w-full text-sm text-slate-400 hover:text-slate-600" data-testid="forgot-cancel-btn">
            Cancelar
          </button>
        )}
      </div>
    </div>
  );
};
